import { legacy_createStore as createStore, compose, applyMiddleware } from 'redux'
import { save, load } from 'redux-localstorage-simple'
import { connectRouter, routerMiddleware } from 'connected-react-router'

import history from './history'
import rootReducer from 'reducers'

const localStorageStates = ['user', 'sectionsIndex']
const localStorageNamespace = 'viewer'

const composeEnhancers =
  process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose

const enhancer = composeEnhancers(
  // Save some states in the Local Storage. The 'save' method is called
  // by Redux each time an action is handled by your reducer
  applyMiddleware(save({ states: localStorageStates, namespace: localStorageNamespace })),
  // Build the middleware for intercepting and dispatching navigation actions
  applyMiddleware(routerMiddleware(history))
)

export default function configureStore(initialState) {
  return createStore(
    connectRouter(history)(rootReducer),
    load({
      states: localStorageStates,
      namespace: localStorageNamespace,
      preloadedState: initialState,
    }),
    enhancer
  )
}
